<script lang="ts">
  import { onMount } from 'svelte';

  import { t, locale } from 'svelte-i18n';

  export let hideLarge = false;
  export let darkMode = false;

  let isEnglish: boolean;

  onMount(() => {
    locale.subscribe((iso) => {
      isEnglish = iso.includes('en');
    });
  });
</script>

<footer
  class="leading-6 md2:leading-8
         text-base sm:text-xxs md2:text-xs
         text:black
         border-t border-opacity-25 border-black 
         px-[1.875rem] md:px-6
         py-7 md2:py-9 {hideLarge ? 'md2:hidden' : ''}"
  class:text-white={darkMode}
  class:border-white={darkMode}
>
  <span class="text-opaque-black">
    {$t('FOOTER.FIRST')}
    {#if !isEnglish}
      <br class="md2:hidden" />
    {/if}
    {$t('FOOTER.SECOND')}
  </span>
  <a href={`mailto:${$t('FOOTER.EMAIL')}`}>{$t('FOOTER.EMAIL')}</a>
</footer>

<style>
</style>
